import Vue from 'vue'
import Vuetify from 'vuetify'
import store from '~/store'
import router from '~/router'
import {
  i18n
} from '~/plugins'
import App from '~/components/App'
import '~/components'
import VueSignaturePad from 'vue-signature-pad'
import VueApexCharts from 'vue-apexcharts'

Vue.use(Vuetify, {
  iconfont: 'md',
  theme: {
    primary: '#004990',
    accent: '#FF9900'
  }
})
Vue.use(VueSignaturePad)
Vue.use(VueApexCharts)

Vue.component('apexchart', VueApexCharts)

Vue.config.productionTip = false

if (process.env.NODE_ENV === 'production') {
  Vue.config.devtools = false
  Vue.config.debug = false
  Vue.config.silent = true
}

new Vue({
  el: '#app',
  i18n,
  store,
  router,
  ...App
})



// WEBPACK FOOTER //
// ./resources/assets/js/app.js